import {DomainError} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'

export class DomainSharedError extends DomainError {
  constructor({cause, code, message}) {
    super({cause, code, message})
  }

  static isDomainError({error}) {
    return error instanceof DomainError
  }

  static createFromPrimitives({cause, code, message}) {
    return new DomainSharedError({cause, code, message})
  }

  static createGenericError({cause}) {
    const {ERROR_RESPONSES} = ConfigContext.get('COMMON')

    return new DomainSharedError({
      cause,
      code: ERROR_RESPONSES.BASE.GENERIC_ERROR.CODE,
      message: ERROR_RESPONSES.BASE.GENERIC_ERROR.MESSAGE
    })
  }

  static createNoContentError({cause}) {
    const {ERROR_CODES} = ConfigContext.get('COMMON')

    return new DomainSharedError({
      cause,
      code: ERROR_CODES.NO_CONTENT,
      message: 'No content error message'
    })
  }

  static createGatewayTimeoutError({cause}) {
    const {ERROR_CODES} = ConfigContext.get('COMMON')

    return new DomainSharedError({
      cause,
      code: ERROR_CODES.GATEWAY_TIMEOUT,
      message: 'Gateway timeout error message'
    })
  }

  static createInternalServerError({cause}) {
    const {ERROR_CODES} = ConfigContext.get('COMMON')

    return new DomainSharedError({
      cause,
      code: ERROR_CODES.INTERNAL_SERVER_ERROR,
      message: 'Internal server error message'
    })
  }

  static createUnavailableForLegalReasonsError({cause}) {
    const {ERROR_CODES} = ConfigContext.get('COMMON')

    return new DomainSharedError({
      cause,
      code: ERROR_CODES.UNAVAILABLE_FOR_LEGAL_REASONS,
      message: 'Unavailable for legal reasons error message'
    })
  }

  static createUnprocessableContentError({cause}) {
    const {ERROR_CODES} = ConfigContext.get('COMMON')

    return new DomainSharedError({
      cause,
      code: ERROR_CODES.UNPROCESSABLE_CONTENT,
      message: 'Unprocessable content error message'
    })
  }

  static createBadRequestError({cause}) {
    const {ERROR_CODES} = ConfigContext.get('COMMON')

    return new DomainSharedError({
      cause,
      code: ERROR_CODES.BAD_REQUEST,
      message: 'Bad request error message'
    })
  }
}
